/*
 * @Author: Merlin
 * @Date: 2024-01-30 10:46:04
 * @LastEditors: Merlin
 * @LastEditTime: 2024-03-14 17:51:53
 * @Description: 
 */
import { useAmountMemoryStore } from '~/stores/cansino/amountMemory';
export interface BetForm {
    amount: number;
    isFast: boolean;
    frontID: number;
    type: number;
    count?: number;
    prediction?: Array<number>|number;
}


export const useMinesSocket = (rootPath = 'games') => {

    const EMIT_MINES_BET = async (data: BetForm) => {
        const amountMemory = useAmountMemoryStore();
        if (data.amount) {
            amountMemory.setLastAmount(data.amount);
        }
        const res = await asyncEmit(
            `${rootPath}.mines.bet`, 
            {...data},
        );
        return res;
    };
    
    return {
        EMIT_MINES_BET
    };
};


